import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import {
  CloseToOrAward,
  AwardCategory,
  style,
  getAwardTitles,
  awardPrefixes,
} from '../../api';
import { Text, TextRegular12 } from '../common/Text';
import ProgressBar from './ProgressBar';
import AwardCard from './AwardCard';
import { desktop } from '../../style/constants';

interface Props {
  category: AwardCategory;
  award: CloseToOrAward;
  showDescription?: boolean;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

const CloseSubtitle = styled(Text)`
  font-weight: bold;
  font-size: 14;
  text-align: center;
  @media ${desktop} {
    font-size: 18px;
  }
`;

const CloseContainer = styled(Container)`
  display: flex;
  margin-top: 2rem;
  max-width: 10rem;
  justify-content: flex-start;
  text-align: center;
  @media ${desktop} {
    max-width: 295rem;
  }
`;

const ProgessContainer = styled(Container)`
  flex: 0;
  margin-top: 8px;
  width: 200px;
  max-width: 100%;
`;

const ProgressText = styled(Text)`
  font-size: 10px;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
`;

const DescriptionText = styled(TextRegular12)`
  line-height: 1.5;
  max-width: 216px;

  @media ${desktop} {
    font-size: 14px;
  }
`;

const CloseToAward = ({ award, category, showDescription = false }: Props) => {
  const { unit, subTitle, description } = getAwardTitles(award);
  const { t } = useTranslation('awards');
  return (
    <Container
      style={{
        borderBottom: `1px solid ${style.grey_light_2_new}`,
        marginBottom: 6,
      }}
    >
      <AwardCard hideSubtitle award={award} />
      <CloseContainer>
        <CloseSubtitle>
          {t(awardPrefixes[category as AwardCategory]) as string}{' '}
          {subTitle && (t(subTitle) as string)}
        </CloseSubtitle>
        {!!(award.required && award.left) && (
          <ProgessContainer>
            <>
              <ProgressBar total={award.required} left={award.left} />
              <ProgressText>
                {t('awards:only')} {award.left} {unit && t(unit)}{' '}
                {t('awards:left')}
              </ProgressText>
            </>
          </ProgessContainer>
        )}
        {!!(description && showDescription) && (
          <DescriptionText>{t(description)}</DescriptionText>
        )}
      </CloseContainer>
    </Container>
  );
};

export default CloseToAward;
